module.exports = __webpack_public_path__ + "static/img/sec1-bg.20cc92f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-bg.jpg
// module id = Rop0
// module chunks = 0